import { useTranslation } from "react-i18next";
import { PopperTooltip } from "~/common/components/Tooltip";
import { ActionTextLinkCell } from "./ActionCellPrimitives";
import CadIcon from "~/common/mui/icons/Cad";
import { styled } from "~/common/mui";

interface CadButtonProps {
  url?: string;
  hasCad?: boolean;
  onClick?: () => void;
  target?: string;
  "data-test-id"?: string;
  "data-ta-spec"?: string;
  "data-ta-title"?: string;
  className?: string;
}

export const OpenCadAction = ({ url, hasCad, className, ...rest }: CadButtonProps) => {
  const { t } = useTranslation();
  let element = (
    <ActionTextLinkCell
      cad
      className={className}
      href={url}
      missingCad={!hasCad}
      {...rest}
    >
      <CadIcon sx={{ fontSize: 24 }} />
    </ActionTextLinkCell>
  );

  if (!hasCad) {
    element = (
      <ActionTooltip
        tooltipContent={t("product.requestCad")}
        placement="bottom-end"
        isNavigation
        className="scha__personal-nav__tooltip"
      >
        {element}
      </ActionTooltip>
    );
  }

  return element;
};

const ActionTooltip = styled(PopperTooltip)({
  height: "100%",
  display: "flex",
  alignItems: "center",
});
